import CoinToss from "../components/CoinToss";

const CoinTossPage: React.FC = () => <CoinToss />;

export default CoinTossPage;
